import { useCallback, useEffect, useState } from 'react';

// Lo que permite el plan (diagnosticos al mes y participantes), pedido al entrar en el
// primer paso para avisar antes de seguir. El servidor vuelve a comprobarlo al crear.
export function usePlanLimits() {
  const [limits, setLimits] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const token = localStorage.getItem('token');
    if (!token) return undefined;
    fetch(`${process.env.REACT_APP_API_URL}/plan-limits`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => { if (!cancelled) setLimits(data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  // Devuelve los `detalles` con el mismo formato que el 403 del servidor, o null si se puede seguir
  return useCallback((participantCount) => {
    if (!limits) return null;
    if (limits.puedeCrear === false) {
      return {
        plan: limits.plan,
        limite: limits.limite,
        encuestasCreadas: limits.encuestasCreadas,
        fechaInicio: limits.fechaInicio,
        fechaFin: limits.fechaFin,
      };
    }
    if (limits.maxParticipantes != null && participantCount > limits.maxParticipantes) {
      return {
        plan: limits.plan,
        maxParticipantes: limits.maxParticipantes,
        participantesSolicitados: participantCount,
      };
    }
    return null;
  }, [limits]);
}
